import Banner from "./components/Banner";
import { getBanners } from "./utils/api";
import { ErrorAlert, Header, useFetchData } from "@";

const Index = () => {
  // Define breadcrumb links
  const links = [{ name: "بانر الصفحة الرئيسية", link: "" }];

  // Fetch banners data
  const { data, error, fetchData } = useFetchData({
    noPgn: true,
    fun: getBanners,
  });

  return (
    <>
      {/* Display error alert if there is an error */}
      <ErrorAlert reload={fetchData} show={error} />

      {/* Page header */}
      <Header title="بانر الصفحة الرئيسية" links={links} />

      <div className="grid gap-5 lg:grid-cols-2">
        {/* Display first banner */}
        <Banner title="البنر الأول" data={data[0]} />

        {/* Display second banner */}
        <Banner title="البنر الثاني" data={data[1]} />
      </div>
    </>
  );
};

export default Index;
